module.exports = __webpack_public_path__ + "static/chat-669212520b10884ff94236f9d298b588.png";